import {CAP_DIRECTION} from '@/globals';
import {CableCoreModel} from './cable-core.model';
import {CableModel} from './cable.model';

export interface EquipmentCapModel {
    id: string;
    title: string;
    locationId: string;
    capDirection: CAP_DIRECTION;
    sortOrder: number;
    isActive: boolean;
    created: string;

    cableEntryType?: string;
    modelNo?: string;
    certificationNo?: string;
    manufacturer?: string;
    serialNo?: string;
    protectionType?: string[];

    inCables?: CableModel[];
    outCables?: CableModel[];
    inCores?: CableCoreModel[];
    outCores?: CableCoreModel[];
}

export class CreateEditEquipmentCapViewModel implements Omit<EquipmentCapModel, 'id' | 'locationId' | 'isActive' | 'created'> {
    id?: string;
    title: string;
    capDirection: CAP_DIRECTION;
    sortOrder: number;

    cableEntryType?: string;
    modelNo?: string;
    certificationNo?: string;
    manufacturer?: string;
    serialNo?: string;
    protectionType?: string[];

    constructor(data: CreateEditEquipmentCapViewModel) {
        Object.assign(this, data);
    }
}

export interface UpdateCapSortOrderEquipmentCapModel {
    dragedCapId: string;
    targetCapId: string;
    where: 'before' | 'after';
}
